// extracted by mini-css-extract-plugin
export default {"arrowRight":"arrowRight--MAXUW","arrowDown":"arrowDown--y6Y5o"};